import { render } from "./landingPage.vue?vue&type=template&id=372c2676"
import script from "./landingPage.vue?vue&type=script&lang=js"
export * from "./landingPage.vue?vue&type=script&lang=js"

import "./landingPage.vue?vue&type=style&index=0&id=372c2676&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__